/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Gemini_Web_AddInputs */

const en_mcp_gemini_web_add = /** @type {(inputs: Mcp_Gemini_Web_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under Custom apps, choose Add a custom app and paste the MCP URL.`)
};

const es_mcp_gemini_web_add = /** @type {(inputs: Mcp_Gemini_Web_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Custom apps, elige Add a custom app y pega la URL de MCP.`)
};

/**
* | output |
* | --- |
* | "Under Custom apps, choose Add a custom app and paste the MCP URL." |
*
* @param {Mcp_Gemini_Web_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_gemini_web_add = /** @type {((inputs?: Mcp_Gemini_Web_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Gemini_Web_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_gemini_web_add(inputs)
	return en_mcp_gemini_web_add(inputs)
});